import { useFetch } from '../../../hooks';
import { getVisitStats } from '../../../api';
import { extractShortId } from '../utils/urlUtils';

export const useUrlShortener = (
  demoUrl: string | null,
  enabled: boolean = true
) => {
  const shortId = extractShortId(demoUrl);
  const shouldSkip = !enabled || !demoUrl || !shortId;

  const { data: visitStats, loading: isLoadingStats } = useFetch(
    async () => {
      if (!shortId) {
        return null;
      }
      return await getVisitStats(shortId);
    },
    [shortId, enabled],
    {
      skip: shouldSkip,
      initialData: null,
      onError: false,
    }
  );

  return {
    visitStats: visitStats || null,
    isLoadingStats,
  };
};
